var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],class:_vm.classList,attrs:{"width":_vm.iconSize,"height":_vm.iconSize}},[_c('use',_vm._b({attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink"}},'use',{ 'xlink:href': '#' + _vm.type },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }